import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLang } from "@/contexts/LangContext";
import { useLanguagePreference } from "@/hooks/useLanguagePreference";
import { LANGUAGES } from "@/const/languages";

export default function LanguageSwitcher() {
  const { t } = useLang();
  const { lang, selectLanguage } = useLanguagePreference();

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="lang-switcher"
          aria-label={t("lang_switcher_label")}
          title={t("lang_switcher_label")}
          data-testid="lang-switcher"
        >
          <Globe size={13} aria-hidden="true" />
          <span className="lang-switcher-code">{lang.split("-")[0]}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={6} className="lang-menu" data-testid="lang-menu">
        <DropdownMenuRadioGroup value={lang} onValueChange={selectLanguage}>
          {LANGUAGES.map(({ code, label }) => (
            <DropdownMenuRadioItem
              key={code}
              value={code}
              lang={code}
              className="lang-menu-option"
              data-testid={`lang-option-${code}`}
            >
              {label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
